var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9838 32.9034C14.951 34.3999 19.333 34.3636 23.2748 32.8014V1.19863C19.333 -0.363583 14.951 -0.399944 10.9838 1.09664V32.9034Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3831 0.952118C8.0569 2.11547 5.1745 4.285 3.13506 7.16022C1.09561 10.0354 0 13.4741 0 17C0 20.5259 1.09561 23.9645 3.13506 26.8398C5.1745 29.715 8.0569 31.8845 11.3831 33.0479V0.952118Z",
    fill: "#0B55B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1474 1.14763V32.8524C26.3431 31.6138 29.0898 29.4369 31.0266 26.6078C32.9635 23.7786 34 20.4294 34 17C34 13.5706 32.9635 10.2214 31.0266 7.3922C29.0898 4.56303 26.3431 2.38622 23.1474 1.14763Z",
    fill: "#D60A2E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.d3230db549fa90c8c78bb3f40937b641.svg";
export { ForwardRef as ReactComponent };